import React from 'react';
import iconLogo from '../assets/Icon_logo.svg';
import wordMarkLogo from '../assets/word_mark_logo.svg';

export const Logo = ({ type = 'icon', className = '', width = 'auto', height = 'auto' }) => {
  const logoSrc = type === 'wordmark' ? wordMarkLogo : iconLogo;
  
  return (
    <img
      src={logoSrc}
      alt="EasyProperty Logo"
      className={className}
      style={{ width, height }}
    />
  );
};

export default Logo;